import * as actionTypes from '../actions/actionTypes';

const initialState = { sellers: [] }

const sellersReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_SELLERS_LIST:
            {
                return {
                    ...state,
                    sellers: action.sellers
                }
            }
        case actionTypes.CREATE_SELLER:
            {
                return {
                    ...state,
                    sellers: [...state.sellers, action.seller]
                }
            }
        case actionTypes.UPDATE_SELLER:
            {
                return {
                    ...state,
                    sellers: state.sellers.map((item) => {
                        if (item.id === action.data.id) {
                            return {...action.data }
                        }
                        return item
                    })
                }
            }
        case actionTypes.DELETE_SELLER:
            {
                console.log(action)
                return {
                    ...state,
                    sellers: state.sellers.filter(seller => seller.id !== action.id)
                }
            }
        case actionTypes.CLEAR_SELLER:
            {
                return initialState;
            }
        default:
            {
                return state;
            }
    }
}

export default sellersReducer;